module.exports = __webpack_public_path__ + "static/witch_4k-29ca2d1f279700a9a38739bfcd6fc62a.webp";